import { Product } from "../types/product"; 
import { createApiStore } from "./genericStore";
import api from "../service/api"; // 🌟 Ortak axios instance'ın

// Base store tanımını "/stock" endpoint'i ile yapıyoruz
const useProductBaseStore = createApiStore<Product>("/stock");

export const useProductStore = () => {
    const store = useProductBaseStore();

    return {
        ...store,

        // ==========================================
        // STOK EXCEL DIŞARI AKTARMA (EXPORT)
        // ==========================================
        exportExcel: async (type: "template" | "all") => {
            try {
                // Backend'deki yeni query parametreli endpoint yapısına bağlıyoruz
                const endpoint = type === "template" 
                    ? "/excel/stock/export?template=true" 
                    : "/excel/stock/export";

                // Ortak interceptor yapısından geçerek güvenle arraybuffer istiyoruz
                const response = await api.get(endpoint, {
                    responseType: "arraybuffer",
                    headers: { "x-global-load": "true" }
                });

                // Interceptor koruması: response objesinin katmanını kontrol et
                const rawData = (response as any).data ? (response as any).data : response;

                // Saf binary veriden Excel blobu oluşturma
                const blob = new Blob([rawData], { 
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                });
                
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                
                // İndirilecek dosya ismini tipine göre ayarlıyoruz
                const fileName = type === "template" ? "Stok_Yukleme_Sablonu.xlsx" : "Stok_Listesi_Export.xlsx";
                link.setAttribute("download", fileName);
                
                document.body.appendChild(link);
                link.click();
                
                // DOM ve Bellek temizliği
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Stok Excel dışarı aktarılırken hata oluştu:", error);
                throw error;
            }
        },

        // ==========================================
        // STOK EXCEL İÇERI AKTARMA (IMPORT)
        // ==========================================
        importExcel: async (file: File) => {
            try {
                const formData = new FormData();
                formData.append("file", file);

                const response = await api.post("/excel/stock/import", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });

                // Yükleme başarılı olduktan sonra arayüzdeki stok listesini dinamik olarak yeniliyoruz
                await store.fetchDataDynamic();
                return response.data;
            } catch (error) {
                console.error("Stok Excel içeri aktarılırken hata oluştu:", error);
                throw error;
            }
        }
    };
};